'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _actionTypes = require('./action-types');

var _actionTypes2 = _interopRequireDefault(_actionTypes);

var _abp = require('abp');

var _abp2 = _interopRequireDefault(_abp);

var _actions = require('linksoft/core/actions');

var _actions2 = _interopRequireDefault(_actions);

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _values = require('lodash/values');

var _values2 = _interopRequireDefault(_values);

var _ajax = require('linksoft/utils/ajax');

var _notify = require('linksoft/notify');

var _notify2 = _interopRequireDefault(_notify);

var _message = require('linksoft/message');

var _message2 = _interopRequireDefault(_message);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var resx = (0, _localize2.default)("App");

var moduleActions = {

    // update complaint state 
    update: function update(item) {
        return { type: _actionTypes2.default.UPDATE, item: item };
    },
    submit: function submit() {
        return function (dispatch, getState) {
            var data = (0, _values2.default)(getState().complaints.items);
            dispatch({ type: _actionTypes2.default.SUBMIT });
            _abp2.default.services.api.complaint.create(data).done(function (result) {
                dispatch({ type: _actionTypes2.default.SUBMITTED });
                _notify2.default.success(resx.App.ComplaintCreatedSuccessfully);
                var url = location.protocol + "//" + location.host;
                $("#complaint-summary").html('<a class=\'btn btn-primary create-complaint\' href=\'' + url + '/Complaint/Detail/' + result + '\' target=\'_blank\'>' + resx.App.Complaints + '</a>');
            }).fail(function (e) {
                _message2.default.error(e);
                dispatch({ type: _actionTypes2.default.SUBMIT_FAILED });
            });

            dispatch({ type: _actionTypes2.default.SUBMIT });
        };
    },
    submitted: function submitted() {
        return { type: _actionTypes2.default.SUBMITTED };
    },
    cancelled: function cancelled() {
        $("#complaint-summary").html('');
        return { type: _actionTypes2.default.CANCELLED };
    },

    changeStatus: function changeStatus() {
        return function (dispatch) {
            (0, _ajax.submitForm)($("#complaint-form")[0]);
            dispatch({ type: _actionTypes2.default.STATUS_CHANGED });
        };
    }

};

_actions2.default.add('complaints', moduleActions);

exports.default = moduleActions;


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/complaints/actions.js
// module id = 417
// module chunks = 0